import { Observable } from 'rxjs';
import { Gear } from '../models/gear.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GearService {
  constructor(private http: HttpClient) {}

  calculateRequiredGear(
    ratedFrequency: number,
    maxFrequency: number,
    motorSpeed: number,
    maxPumpSpeed: number
  ): Observable<Gear> {
    const request = {
      ratedFrequency: ratedFrequency,
      maxFrequency: maxFrequency,
      motorSpeed: motorSpeed,
      maxPumpSpeed: maxPumpSpeed
    };

    const calculationUrl = `${environment.calculationApi}/v1/gear/required`;
    return this.http.post<Gear>(calculationUrl, request);
  }

  calculateSelectedGear(
    motorSpeed: number,
    selectedI: number | null,
    selectedN: number | null
  ): Observable<Gear> {
    const request = {
      motorSpeed: motorSpeed,
      selectedI: selectedI,
      selectedN: selectedN,
    };

    const calculationUrl = `${environment.calculationApi}/v1/gear/selected`;
    return this.http.post<Gear>(calculationUrl, request);
  }
}
